import React from "react";

interface ArticleSchemaProps {
  title: string;
  description: string;
  url: string;
  image: string;
  publishedAt: string;
  updatedAt: string;
  author: string;
  category: string;
}

export default function ArticleSchema({
  title,
  description,
  url,
  image,
  publishedAt,
  updatedAt,
  author,
  category
}: ArticleSchemaProps) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "image": [image],
    "author": {
      "@type": "Person",
      "name": author
    },
    "publisher": {
      "@type": "Organization",
      "name": "Recruteurs.io",
      "logo": {
        "@type": "ImageObject",
        "url": "https://recruteurs.io/logo.png"
      }
    },
    "datePublished": publishedAt,
    "dateModified": updatedAt,
    "description": description,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "articleSection": category
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(jsonLd)}
    </script>
  );
}